import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { createFileRoute, Link, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const auth = context.msalInstance;
    const accounts = auth?.getAllAccounts() ?? [];

    if (accounts.length === 0) {
      await auth?.loginRedirect();
    }
    throw redirect({
      to: '/folder',
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <AuthenticatedTemplate>
        <p>Your are logged in, but the redirect failed.</p>
        <Link to="/folder">PermissionManager</Link>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>Redirect to SSO Log in page failed. Please Log in manually.</UnauthenticatedTemplate>
    </>
  );
}
